import { useParams, Link } from 'react-router-dom';
import { useEffect, useMemo } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import ContentSection from './components/ContentSection';
import CommentSection from './components/CommentSection';
import { articles } from '@/mocks/articles';

export default function ArticlePage() {
  const { slug } = useParams<{ slug: string }>();
  const article = useMemo(() => articles.find((a) => a.slug === slug), [slug]);

  useEffect(() => {
    if (!article) return;
    document.title = `${article.title} - 吃瓜每日榜单`;
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', article.excerpt);
    }
    return () => {
      document.title = '吃瓜每日榜单 - 第一现场,今日必看,实时追踪 | 新鲜大瓜,瓜王争霸';
      if (metaDesc) {
        metaDesc.setAttribute('content', '吃瓜每日榜单，网罗全网最新最热的娱乐八卦、社会热点、网络爆料。每日更新热榜排名，第一现场实时追踪，新鲜大瓜不容错过，瓜王争霸谁与争锋！');
      }
    };
  }, [article]);

  if (!article) {
    return (
      <>
        <Navbar />
        <div className="min-h-screen flex flex-col items-center justify-center pt-16 px-4">
          <div className="text-center space-y-4">
            <i className="ri-emotion-sad-line text-5xl text-foreground-300"></i>
            <h1 className="text-2xl font-heading font-bold text-primary-900">这个瓜好像还没熟...</h1>
            <p className="text-foreground-500 text-sm">文章找不到了，要不回首页看看其他热乎的瓜？</p>
            <Link
              to="/"
              className="inline-block px-5 py-2.5 rounded-lg bg-primary-900 text-background-50 text-sm font-semibold hover:bg-primary-800 transition-colors whitespace-nowrap"
            >
              返回首页
            </Link>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  const schemaData = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.title,
    description: article.excerpt,
    image: article.coverImage,
    datePublished: article.publishedAt,
    author: {
      '@type': 'Person',
      name: article.author.name,
    },
    publisher: {
      '@type': 'Organization',
      name: '吃瓜每日榜单',
    },
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': `http://yyweilai.com/article/${article.slug}`,
    },
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
      />
      <Navbar />
      <main>
        <HeroSection
          title={article.title}
          excerpt={article.excerpt}
          coverImage={article.coverImage}
          category={article.category}
          tags={article.tags}
          publishedAt={article.publishedAt}
          views={article.views}
          author={article.author}
        />
        <ContentSection
          content={article.content}
          author={article.author}
        />
        <CommentSection />
      </main>
      <Footer />
    </>
  );
}
